import { Flex, Heading } from '@chakra-ui/react';
import { ReactNode } from 'react';

type PageHeaderProps = {
	/** Page title. Accepts a node so pages can append badges (e.g. book level). */
	title: ReactNode;
	/** Actions/filters row: search, selects, primary button, etc. */
	children?: ReactNode;
};

/**
 * Consistent page header used across the management pages. Replaces the
 * per-page white bars that each hard-coded a different fixed height. The title
 * uses the display face; the actions row is laid out by the page.
 */
export const PageHeader = ({ title, children }: PageHeaderProps) => {
	return (
		<Flex
			direction="column"
			gap="14px"
			bg="white"
			px={{ base: 4, md: 6 }}
			py={5}
			borderBottom="1px solid"
			borderColor="mist"
			flexShrink={0}
		>
			<Heading as="h1" fontSize={{ base: '22px', md: '26px' }} textTransform="uppercase" color="ink">
				{title}
			</Heading>
			{children}
		</Flex>
	);
};
